var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { compose } from 'recompose';
import { sortRecords } from 'components/common/responsive-table/ResponsiveTable';
import TableCard from 'components/common/table-card/TableCard';
import withRedirectToOutsideApp from 'components/common/with-redirect-to-outside-app/withRedirectToOutsideApp';
import { appSelectors } from 'redux/ducks/app';
import { CW_TABLE_SELECTOR } from 'reports/cw/constants/cw.constant';
import { ASSIGNMENT_TYPE_GROUPS, getAssignmentTypeById } from 'reports/cw/constants/report.constant';
import { cwSelectors } from 'reports/cw/redux/ducks/cw';
import { querySelectorWrapper } from 'services/method-wrapper.service';
import { renderClassAvgGrade, renderClassAvgTimeSpent, renderDueDate, renderName, renderPercentCompletion, renderScoringType } from '../assignment-engagement-table-helper/AssignmentEngagementTableHelper';
var AssignmentEngagementTableMobile = function (_a) {
    var _b;
    var featureFlags = _a.featureFlags, tableData = _a.tableData, assignmentTypeId = _a.assignmentTypeId, searchKeyword = _a.searchKeyword, xLinkId = _a.xLinkId, isBackToPreviousAppIconShown = _a.isBackToPreviousAppIconShown, courseId = _a.courseId, onRedirectToOutsideApp = _a.onRedirectToOutsideApp;
    var isEAQAssignmentType = ((_b = getAssignmentTypeById(assignmentTypeId)) === null || _b === void 0 ? void 0 : _b.group) === ASSIGNMENT_TYPE_GROUPS.EAQ;
    var assignmentEngagementCardAndTableSortInteraction = useSelector(function (state) { return cwSelectors.getAssignmentEngagementCardAndTableSortInteraction(state); });
    var _c = useState(tableData), sortedTableData = _c[0], setSortedTableData = _c[1];
    var percentCompleteRow = { field: 'percentCompletion', header: '% Complete', customRenderContent: renderPercentCompletion };
    var classAvgScoreRow = {
        field: 'classAvgScore',
        header: 'Class Avg Score',
        customRenderContent: renderClassAvgGrade,
        sortNARecordInBottom: true
    };
    var defaultrows = {
        default: [
            percentCompleteRow,
            classAvgScoreRow,
            {
                field: 'classAvgTimeSpentSeconds',
                header: isEAQAssignmentType ? 'Class Avg Time Spent per Question' : 'Class Avg Time Spent',
                customRenderContent: renderClassAvgTimeSpent
            }
        ],
        expanded: [{ field: 'classAvgScore', header: '#Past Due' }]
    };
    var defaultFields = [
        percentCompleteRow,
        { field: 'scoringType', header: 'Scoring Type', customRenderContent: renderScoringType },
        classAvgScoreRow
    ];
    var expandedFields = [
        {
            field: 'classAvgTimeSpentSeconds',
            header: isEAQAssignmentType ? 'Class Avg Time Spent per Question' : 'Class Avg Time Spent',
            customRenderContent: renderClassAvgTimeSpent
        },
        { field: 'dueDate', header: 'Due Date', customRenderContent: renderDueDate }
    ];
    var customExpandRows = {
        default: defaultFields,
        expanded: isEAQAssignmentType ? __spreadArray([{ field: 'numberOfAvgQuestionAttempt', header: 'Avg # Questions Attempted ' }], expandedFields, true) : expandedFields
    };
    var recordColumns = __spreadArray(__spreadArray([], customExpandRows.default, true), customExpandRows.expanded, true);
    useEffect(function () {
        var _a;
        if (assignmentEngagementCardAndTableSortInteraction) {
            var field = assignmentEngagementCardAndTableSortInteraction.field, sortDirection = assignmentEngagementCardAndTableSortInteraction.sortDirection;
            setSortedTableData(sortRecords(recordColumns, __spreadArray([], tableData, true), field, sortDirection));
            (_a = querySelectorWrapper(CW_TABLE_SELECTOR.assignmentEngagement)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [assignmentEngagementCardAndTableSortInteraction, tableData]); // eslint-disable-line react-hooks/exhaustive-deps
    var renderTitle = function (row) {
        return renderName({ row: row, featureFlags: featureFlags, courseId: courseId, xLinkId: xLinkId, isBackToPreviousAppIconShown: isBackToPreviousAppIconShown, searchKeyword: searchKeyword, assignmentTypeId: assignmentTypeId, onRedirectToOutsideApp: onRedirectToOutsideApp });
    };
    return (<div className="c-cw-assignment-engagement-table">
      {sortedTableData.map(function (row, index) {
            var title = renderTitle(sortedTableData[index]);
            return <TableCard key={row.id} hideTitleIcon data={row} title={title} rows={defaultrows} customExpandRows={customExpandRows}/>;
        })}
    </div>);
};
var mapStateToProps = function (state) { return ({
    assignmentEngagementCardAndTableSortInteraction: cwSelectors.getAssignmentEngagementCardAndTableSortInteraction(state),
    courseId: appSelectors.getSelectedCourse(state),
    featureFlags: appSelectors.getFeatureFlags(state),
    xLinkId: appSelectors.getLinkId(state)
}); };
var enhancers = [connect(mapStateToProps), withRedirectToOutsideApp];
export { AssignmentEngagementTableMobile as AssignmentEngagementTableMobileBase };
export default compose.apply(void 0, enhancers)(AssignmentEngagementTableMobile);
